import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { DateInDefaultTimezonePipeModule } from '@localization-lib/date-time/pipes/date-in-default-timezone/date-in-default-timezone-pipe.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { SkeletonModule } from '@shared-util-lib/directives/skeleton/skeleton.module'
import { ExceedablePipeModule } from '@wagon-hire/exceedable/exceedable-pipe/exceedable.pipe.module'
import { WagonHireHistoryRequestHeaderComponent } from './wagon-hire-history-request-header.component'

@NgModule({
    declarations: [WagonHireHistoryRequestHeaderComponent],
    exports: [WagonHireHistoryRequestHeaderComponent],
    imports: [
        CommonModule,
        MatIconModule,
        TranslationModule,
        DateInDefaultTimezonePipeModule,
        ExceedablePipeModule,
        SkeletonModule,
    ],
})
export class WagonHireHistoryRequestHeaderModule {}
